<template>
  <base-template current-page="IntegrationsIndex">
    <router-view></router-view>
  </base-template>
</template>

<script>
import BaseTemplate from "../BaseTemplate";

export default {
  name: "IntegrationsIndex",
  components: { BaseTemplate },
};
</script>
